import React, { useState, useRef, useEffect } from 'react';
import styles from './PercentInput.scss';
import NumberFormat from 'react-number-format';
import Formatter from './Formatter';
import NumberField from '../MaterialUi/NumberField';

export interface IPercentInputProps {
    type: 'number';
    pattern: string;
    value: number;
    name: string;
    label: string;
    onChange: (name: string, value: number) => void;

    base: number;
}

const PercentInput: React.FC<React.PropsWithChildren<IPercentInputProps>> = ({ base, type, pattern, value, name, label, onChange }) => {
    const abs = value ? (base * value) / 100 : 0;

    const handleValueChange = (name, value) => {
        onChange(name, value);
    };

    return (
        <div className={styles.percentInput}>
            <div>
                <span className={styles.label}>{label}</span>
                <span className={styles.abs}>{Formatter.getNumberString(abs)} €</span>
            </div>
            {/* <div className={styles.abs}>{abs} €</div> */}
            <div>
                {/* <input type={type} name={name} pattern={pattern} value={value} onChange={onChange}></input> */}
                <NumberField
                    label={null}
                    name={name}
                    value={value > 0 ? value : 0}
                    // displayType={'input'}
                    thousandSeparator={'.'}
                    decimalSeparator={','}
                    onChange={handleValueChange}
                    suffix={' %'}
                />
                {/* <span className={styles.percent}>%</span> */}
            </div>
        </div>
    );
};

export default PercentInput;
